import InviteCodeExpiredAndResent from './errors/InviteCodeExpiredAndResent'
import InviteCodeExpired from './errors/InviteCodeExpired'
import { AccountNotFound } from './errors/AccountNotFound'
import * as React from 'react'
import useInviteCodeErrors, { AuthError } from './useInviteCodeErrors'
import { useAppSelector } from '../../store/hooks'
import { selectAuthErrors } from '../../store/auth/authSlice'
import { UnexpectedError } from './errors/UnexpectedError'
import { LoginHeader } from './headers/LoginHeader'
import { SignupHeader } from './headers/SignupHeader'
import { ERROR_ACCOUNT_NOT_FOUND } from '../../common/errorCodes'

export const LoginErrorPanel = () => {
  const authErrors = useAppSelector(selectAuthErrors)
  const { isInviteCodeExpired, isInviteCodeResent } = useInviteCodeErrors(authErrors as AuthError[])

  if (!authErrors) return null

  const firstError = authErrors[0] as AuthError | undefined
  const errorCode = firstError?.errorCode
  const email = firstError?.email
  const errorMessage = firstError?.message ?? ''

  if (isInviteCodeResent) {
    return (
      <div className='auth-container'>
        <SignupHeader hideAccountCreation />
        <InviteCodeExpiredAndResent />
      </div>
    )
  }

  if (isInviteCodeExpired) {
    return (
      <div className='auth-container'>
        <SignupHeader hideAccountCreation />
        <InviteCodeExpired />
      </div>
    )
  }

  if (errorCode === ERROR_ACCOUNT_NOT_FOUND) {
    return (
      <div className='auth-container'>
        <SignupHeader />
        <AccountNotFound email={email} />
      </div>
    )
  }

  return (
    <div className='auth-container'>
      <LoginHeader />
      <UnexpectedError errorMessage={errorMessage} errorCode={errorCode ? String(errorCode) : null} />
    </div>
  )
}
